var map = {
	"./insight_10/main": 1989,
	"./insight_11/main": 2313,
	"./insight_12/main": 2314,
	"./insight_13/main": 2315,
	"./insight_14/main": 2316,
	"./insight_15/main": 2317,
	"./insight_16/main": 2318,
	"./insight_17/main": 2327,
	"./insight_18/main": 2332,
	"./insight_19/main": 2333,
	"./insight_1a/main": 2334,
	"./insight_1ai/main": 2371,
	"./insight_2/main": 2372,
	"./insight_20/main": 2373,
	"./insight_3/main": 2407,
	"./insight_5/main": 2408,
	"./insight_7/main": 2409,
	"./insight_8/main": 2410,
	"./insight_9/main": 2411,
	"./insight_aicopilot/main": 2788,
	"./insight_arcdiagram/main": 2419,
	"./insight_barchart/main": 2793,
	"./insight_boxplot/main": 2811,
	"./insight_bubble/main": 2812,
	"./insight_correlogram/main": 2813,
	"./insight_dendrogram/main": 2814,
	"./insight_density2d/main": 2794,
	"./insight_densityplot/main": 2815,
	"./insight_edgebundling/main": 2420,
	"./insight_funnelplot/main": 2816,
	"./insight_ganttchart/main": 2817,
	"./insight_heatmap/main": 2818,
	"./insight_histogram/main": 2819,
	"./insight_holdout/main": 2795,
	"./insight_image/main": 2421,
	"./insight_kanbanboard/main": 2820,
	"./insight_leaderslaggers/main": 2801,
	"./insight_leveroutcome/main": 2790,
	"./insight_leversbenchmarking/main": 2821,
	"./insight_lineplot/main": 2802,
	"./insight_maps_bubble/main": 2425,
	"./insight_maps_choropleth/main": 2454,
	"./insight_maps_heatmap/main": 2455,
	"./insight_maps_networkovermap/main": 2456,
	"./insight_maps_pins/main": 631,
	"./insight_network/main": 844,
	"./insight_piechart/main": 2822,
	"./insight_radar/main": 2823,
	"./insight_ridgeline/main": 2803,
	"./insight_scatterplot/main": 2804,
	"./insight_sentimentanalysis/main": 2824,
	"./insight_treemap/main": 2825,
	"./insight_violinplot/main": 2826,
	"./insight_wordcloud/main": 2827
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1988;